<template>
  <div class="ui centered grid">
    <div class="one wide column"></div>
    <div v-bind:class="{fourteen:!listofImagesOn,seven:listofImagesOn, wide:true, column:true}">
    
      <h3>Prague Castle around 1621</h3>
    
      <ThePlanView v-bind:extended="false" v-bind:floor_selector="true" v-bind:debug="false" @loadImages="loadRoomImages" v-bind:clickable="true" @changePlanLeyout="listofImagesOn=!listofImagesOn"></ThePlanView>
   
    </div>
    <div v-if="listofImagesOn" class="seven wide column">
       <h3>&nbsp;</h3>
      <div class="ui top attached tabular menu" style="visibility:hidden">
            <div class="item" >&nbsp;</div>
           
        </div>
      <TheAdvancedSearch v-bind:query_props="query" v-bind:margin="false"></TheAdvancedSearch>
    </div>
    <div class="one wide column"></div>
  </div>


</template>

<script>
  import ThePlanView from '../components/ThePlanView.vue'
  import TheCarousel from '../components/TheCarousel.vue'
  import TheAdvancedSearch from '../components/TheAdvancedSearch.vue'
  export default {
    name: 'list',
    components: {
      ThePlanView,
      TheCarousel,
      TheAdvancedSearch
    },
    data() {
      return {
        allRoomData: null,
        room_id: 0,
        message: "This message",
        slides: [],
        query: null,
        listofImagesOn:true

      }
    },


    methods: {

      loadRoomImages: function(room_id, place_id) {
        var query = {}
        query.activeTab = "0";
        query.page = "1";
        query.tabbed = "true";
        query.room = room_id;
        query.place = place_id;
        this.query = query;

      }

    },

    mounted() {
    
   //   var mapWidth=(window.innerHeight-document.getElementById('plan_placer').getBoundingClientRect().y-60)/0.827;
  //    this.planPlacerWidth=mapWidth+"px";
  //    console.log(mapWidth);

    },

    watch: {

    }
  }
</script>

<style scoped>
.plan_placer{
  
 
 
}
</style>



// WEBPACK FOOTER //
// src/router/plan.vue